import axios from "axios";
import { Base_URL } from "../url";

export const saveOfficeDetails = async (officeData, username) => {
  try {
    const response = await axios.post(
      `${Base_URL}/Office/OfficeMaster?UserName=${username}`,
      officeData
    );
    console.log(response);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error saving office details!";
  }
};